const API_BASE_URL = 'https://dms-api-dev.navintaatech.com';
const FILE_UPLOAD_FOLDER_NAME = 'uploads'

const getFileUrlPrefix = () =>{
    return `${API_BASE_URL}/${FILE_UPLOAD_FOLDER_NAME}/`;
}

export  {API_BASE_URL, getFileUrlPrefix};
